module.exports = __webpack_public_path__ + "static/media/up-arrow.613d2243.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-arrow.svg
// module id = 412
// module chunks = 0